import React, { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import styles from './RulesLoadingState.module.scss';

const RulesLoadingState: FC = () => {
    const { t } = useTranslation();

    const loadingIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;

    return (
        <div className={styles['rules-loading-state']}>
            <div className={styles['loading-header']}>
                {t('uploadFiles.policyStep.loadingState.settingUp')}
            </div>
            <div className={styles['loading-content']}>
                <div className={styles['loading-description']}>
                    {t('uploadFiles.policyStep.loadingState.checkingRules')}
                </div>
                <div className={styles['loading-items']}>
                    <div className={styles['loading-item']}>
                        <Spin indicator={loadingIcon} />
                        <span>{t('uploadFiles.policyStep.loadingState.autoProtection')}</span>
                    </div>
                    <div className={styles['loading-item']}>
                        <Spin indicator={loadingIcon} />
                        <span>{t('uploadFiles.policyStep.loadingState.recipientBlocks')}</span>
                    </div>
                    <div className={styles['loading-item']}>
                        <Spin indicator={loadingIcon} />
                        <span>{t('uploadFiles.policyStep.loadingState.availableChoices')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RulesLoadingState;
